/* eslint-disable import/prefer-default-export */
import { landingPageFetch } from './'

export const landingPageDispatchers = (dispatch, props) => ({
  loadLandingPage() {
    dispatch(landingPageFetch(props.params.slug)())
  }
})
